// DeliveryRecord.js
import React, { useEffect, useRef, useState } from "react";

import { getDeliverRecordByDeliver } from "../../service/api/DeliveryRecord/apiDeliveryRecord";
import { RecordSheet } from "../../components/DeliveryRecord";



const DeliveryRecord = () => {
    const [deliversData, setDeliversData] = useState([]);
    useEffect(() => {
        getDeliverRecordByDeliver({ type: 'all' })
            .then(response => {
                if (response?.status === 200) {
                    console.log(response)
                    setDeliversData(response.data.result);
                }
            });
    }, []);
    return (
        <>
            <div className="deliverinfo container mt-4">
                <div className="card shadow p-4 border-0">
                    <h4 className="mb-3 text-primary fw-bold">指派紀錄</h4>
                    <div className="col-lg-12 mb-4">
                        <div className="card">
                            {/* <DeliverSheet
                                data={deliversData} /> */}
                            <RecordSheet
                                data={deliversData} />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export { DeliveryRecord };
